import request from '@/utils/request'

// 查询列表页接口
export const getOrderDetailPage = (params: any) => {
  return request({
    url: '/order/conditionSearch',
    method: 'get',
    params
  })
}

// 查看接口
export const queryOrderDetailById = (params: any) => {
  return request({
    url: `/order/details/${params.orderId}`,
    method: 'get'
  })
}

// 派送接口（需传 storeId）
export const deliveryOrder = (params: any) => {
  return request({
    url: `/order/delivery/${params.id}`,
    method: 'put',
    params: { storeId: params.storeId }
  })
}
// 完成接口（需传 storeId）
export const completeOrder = (params: any) => {
  return request({
    url: `/order/complete/${params.id}`,
    method: 'put',
    params: { storeId: params.storeId }
  })
}

//订单取消
export const orderCancel = (params: any) => {
  return request({
    url: '/order/cancel',
    method: 'put' /*  */,
    data: { ...params }
  })
}

//接单
export const orderAccept = (params: any) => {
  return request({
    url: '/order/confirm',
    method: 'put' /*  */,
    data: { ...params }
  })
}

//拒单
export const orderReject = (params: any) => {
  return request({
    url: '/order/rejection',
    method: 'put' /*  */,
    data: { ...params }
  })
}

// 商户确认退款（后端按支付渠道自动走微信/支付宝退款）
export const orderRefund = (params: any) => {
  return request({
    url: `/order/refund/${params.id}`,
    method: 'put',
    params: { storeId: params.storeId }
  })
}

// 获取待处理，待派送，派送中数量（各商家状态统计，需传分页参数）
export const getOrderListBy = (params: any) => {
  return request({
    url: '/order/statistics',
    method: 'get',
    params
  })
}

// 单店各状态订单数量统计
export const getOrderStatisticsByStore = (storeId: string | number) => {
  return request({
    url: `/order/statistics/${storeId}`,
    method: 'get'
  })
}

// 手动重试上传微信发货信息（商家配送补偿）
export const uploadShippingRetry = (id: number | string) => {
  return request({
    url: `/order/shipping/upload/${id}`,
    method: 'put'
  })
}

export const getAdminCourierTransferCandidates = (orderId: number | string) => {
  return request({
    url: `/order/courier/transferCandidates/${orderId}`,
    method: 'get'
  })
}

export const adminCourierTransfer = (orderId: number | string, data: { targetCourierId: number }) => {
  return request({
    url: `/order/courier/transfer/${orderId}`,
    method: 'put',
    data
  })
}

export const adminCourierReturnToPool = (orderId: number | string) => {
  return request({
    url: `/order/courier/return/${orderId}`,
    method: 'put'
  })
}

/** 赠送预览（任意已支付订单） */
export const giftBucketsPreview = (params: { orderId: number | string; storeId?: number | string }) => {
  return request({
    url: '/order/giftBuckets/preview',
    method: 'get',
    params
  })
}

/** 赠送：入账特惠额度/实物赠品（用户自行下单后再派送） */
export const giftBucketsCreate = (data: {
  orderId: number | string
  storeId?: number | string
  dishId: number | string
  giftBuckets: number
}) => {
  return request({
    url: '/order/giftBuckets',
    method: 'post',
    data
  })
}
